import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAppContext } from "../context/AppContext";
import {
  Box,
  Typography,
  IconButton,
  Paper,
  Avatar,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import {
  Close as CloseIcon,
  Settings as SettingIcon,
  Logout,
} from "@mui/icons-material";
import {
  primary,
  secondary,
  lightBg,
  textsecondary,
} from "../constants/colors";
import Logo from "../assets/logo_2.svg";
import Person from "../assets/Person.svg";
import { FileIcon } from "../components/Icons";
import PeopleIcon from '@mui/icons-material/People';

const FacilitiesSidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const {
    userData,
    isMobile,
    drawerOpen,
    setDrawerOpen,
    guardedNavigate,
  } = useAppContext();

  const [profilePicture, setProfilePicture] = useState(null);
  const [userName, setUserName] = useState("John Doe");

  useEffect(() => {
    setUserName(userData.fullName);
    if (userData.User_Photo_Path !== null && userData.User_Photo_Path !== "") {
      setProfilePicture(userData.User_Photo_Path);
    } else {
      setProfilePicture(Person);
    }
  }, [userData]);

  const menuItems = [
    {
      link: "/facilities/patients",
      icon: <PeopleIcon sx={{ fontSize: "20px" }} />,
      text: "Patients",
    },
    {
      link: "/facilities/provider-requests",
      icon: <FileIcon sx={{ fontSize: "20px" }} />,
      text: "Request Provider Visit",
    },
  ];

  const sidebarContent = (
    <Box
      sx={{
        width: { xs: "100vw", sm: 280 },
        height: "100vh",
        backgroundColor: "#ffffff",
        display: "flex",
        flexDirection: "column",
        // borderRight: { sm: "1px solid #333" },
      }}
    >
      <Box sx={{ p: 2 }}>
        <Box
          display="flex"
          // justifyContent={isMobile ? "space-between" : "center"}
          justifyContent="space-between"
          alignItems="center"
        >
          <img src={Logo} width={"180px"} alt="Logo" />
          {isMobile && (
            <IconButton
              onClick={() => setDrawerOpen(false)}
              sx={{ color: "#999" }}
            >
              <CloseIcon />
            </IconButton>
          )}
        </Box>
      </Box>

      <Box sx={{ flex: 1, paddingX: 2 }}>
        <Box
          sx={{
            px: 2,
            mb: 2,
            backgroundColor: "#F5F5FF",
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
            padding: "8px",
            gap: 1,
          }}
        >
          <Avatar
            sx={{
              width: 40,
              height: 40,
            }}
            src={profilePicture}
          />
          <Box>
            <Typography
              fontSize={"20px"}
              className="sf-medium"
              sx={{
                textTransform: "capitalize",
                color: "#7B7DE5 !important",
                lineHeight: "22px",
              }}
            >
              {userName !== null ? userName : "User"}
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              fontSize={"12px"}
            >
              facility
            </Typography>
          </Box>
        </Box>
        <p style={{ color: "#0000008C", marginBottom: 1, fontSize: "14px" }}>
          Menu
        </p>
        <List>
          {menuItems.map((item, index) => (
            <ListItem
              key={index}
              onClick={() => {
                setDrawerOpen(false);
                guardedNavigate(navigate, item.link);
              }}
              className="class-for-icon"
              sx={{
                cursor: "pointer",
                borderRadius: "8px",
                marginBottom: 0.5,
                alignItems: "center",
                backgroundColor: location.pathname.includes(item.link)
                  ? "#F5F5FF"
                  : "transparent",
                color: location.pathname.includes(item.link)
                  ? primary
                  : textsecondary,
                ".MuiListItemIcon-root": {
                  color: location.pathname.includes(item.link)
                    ? primary
                    : textsecondary,
                },

                "&:hover": {
                  backgroundColor: primary,
                  color: secondary,
                },

                "&:hover .MuiListItemIcon-root": {
                  color: secondary,
                },
              }}
            >
              <ListItemIcon sx={{ minWidth: 32 }}>{item.icon}</ListItemIcon>

              <ListItemText
                primary={item.text}
                TypographyProps={{
                  fontSize: "0.8rem",
                  marginBottom: 0,
                }}
              />
            </ListItem>
          ))}
        </List>
      </Box>

      <Box sx={{ paddingX: 2, paddingY: 1 }}>
        {/* <Button onClick={() => setShowBookingModal(true)}>Book</Button> */}
        {/* <Box
                    // onClick={(e) => setProfileMenuAnchor(e.currentTarget)}
                    onClick={(e) => {
                      setDrawerOpen(false);
                      navigate("/profile");
                    }}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: 1,
                      p: 1,
                      borderRadius: "8px",
                      cursor: "pointer",
                      "&:hover": { backgroundColor: primary, color: secondary },
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Avatar
                        sx={{
                          width: 32,
                          height: 32,
                          backgroundColor: primary,
                          fontSize: "0.875rem",
                          marginRight: "10px",
                        }}
                      >
                        <img src={profilePicture} width={32} height={32} />
                      </Avatar>
                      <Typography variant="body2" className="sf-regular">
                        {userName !== null ? userName : ""}
                      </Typography>
                    </Box>
          
                    <SettingIcon />
                  </Box> */}
        <Box
          onClick={(e) => {
            setDrawerOpen(false);
            guardedNavigate(navigate, "/facilities/profile");
          }}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            gap: 1,
            p: 1,
            borderRadius: "8px",
            cursor: "pointer",
            mb: 0.2,
            color: primary,
            "&:hover": { backgroundColor: primary, color: secondary },
          }}
        >
          <SettingIcon sx={{ fontSize: "20px" }} />
          <Typography variant="body2" className="sf-regular" fontSize={"16px"}>
            Account Settings
          </Typography>
        </Box>
        <Box
          onClick={(e) => {
            localStorage.clear();
            guardedNavigate(navigate, "/login");
          }}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            gap: 1,
            p: 1,
            borderRadius: "8px",
            cursor: "pointer",
            color: primary,
            "&:hover": { backgroundColor: primary, color: secondary },
          }}
        >
          <Logout sx={{ fontSize: "20px" }} />
          <Typography variant="body2" className="sf-regular" fontSize={"16px"}>
            Logout
          </Typography>
        </Box>
      </Box>
    </Box>
  );

  return (
    <>
      {isMobile ? (
        <Drawer
          anchor="left"
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{
            sx: { backgroundColor: "transparent", boxShadow: "none" },
          }}
        >
          {sidebarContent}
        </Drawer>
      ) : (
        <Paper
          elevation={0}
          sx={{
            width: 280,
            backgroundColor: lightBg,
            borderRadius: 0,
            position: "fixed",
            top: 0,
          }}
        >
          {sidebarContent}
        </Paper>
      )}
      {/* <AppointmentBooking
        open={showBookingModal}
        handleClose={() => setShowBookingModal(false)}
      /> */}
    </>
  );
};

export default FacilitiesSidebar;
